var QueryStatus = /* @__PURE__ */ ((QueryStatus2) => {
  QueryStatus2["Pending"] = "pending";
  QueryStatus2["Fulfilled"] = "fulfilled";
  QueryStatus2["Rejected"] = "rejected";
  return QueryStatus2;
})(QueryStatus || {});
export {
  QueryStatus
};
